import type { IconProps } from '@datanomik/core-ui';
import { FinancialClosingIconSvg } from './FinancialClosingIconSvg';

type FinancialClosingIconProps = IconProps;

// 20px is this module's glyph size; `size` is overridable by the caller, so it stays first.
export const FinancialClosingIcon = (props: FinancialClosingIconProps) => (
  <FinancialClosingIconSvg size={20} {...props} />
);
